export const defaultPlaceHolders = ['Start break', 'End break'];
